/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Copy_Event_TextInputs */

const en_event_group_options_copy_event_text = /** @type {(inputs: Event_Group_Options_Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy Event Text`)
};

const fr_event_group_options_copy_event_text = /** @type {(inputs: Event_Group_Options_Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le texte de l'événement`)
};

const de_event_group_options_copy_event_text = /** @type {(inputs: Event_Group_Options_Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignistext kopieren`)
};

const it_event_group_options_copy_event_text = /** @type {(inputs: Event_Group_Options_Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia testo evento`)
};

const ru_event_group_options_copy_event_text = /** @type {(inputs: Event_Group_Options_Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Копировать текст события`)
};

const es_event_group_options_copy_event_text = /** @type {(inputs: Event_Group_Options_Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar texto del evento`)
};

const zh_cn2_event_group_options_copy_event_text = /** @type {(inputs: Event_Group_Options_Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制事件文本`)
};

const ja_event_group_options_copy_event_text = /** @type {(inputs: Event_Group_Options_Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントテキストをコピー`)
};

const hi_event_group_options_copy_event_text = /** @type {(inputs: Event_Group_Options_Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट टेक्स्ट कॉपी करें`)
};

const pt_pt2_event_group_options_copy_event_text = /** @type {(inputs: Event_Group_Options_Copy_Event_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar texto do evento`)
};

/**
* | output |
* | --- |
* | "Copy Event Text" |
*
* @param {Event_Group_Options_Copy_Event_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_copy_event_text = /** @type {((inputs?: Event_Group_Options_Copy_Event_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Copy_Event_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_copy_event_text(inputs)
	if (locale === "de") return de_event_group_options_copy_event_text(inputs)
	if (locale === "it") return it_event_group_options_copy_event_text(inputs)
	if (locale === "ru") return ru_event_group_options_copy_event_text(inputs)
	if (locale === "es") return es_event_group_options_copy_event_text(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_copy_event_text(inputs)
	if (locale === "ja") return ja_event_group_options_copy_event_text(inputs)
	if (locale === "hi") return hi_event_group_options_copy_event_text(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_copy_event_text(inputs)
	return en_event_group_options_copy_event_text(inputs)
});